module.exports = __webpack_public_path__ + "img/64800.7b6ce09c.jpg";